import { useState, useCallback } from "react";

const STORAGE_KEY = "portfolio_os_settings";

export const SETTINGS_DEFAULTS = {
  riskFreeRate:      4.5,         // % for Sharpe ratio
  benchmark:         "SPY",       // benchmark ticker
  pollIntervalMs:    2000,        // live quote polling
  hideBanner:        false,       // hide LiveDataBanner
  alphaKey:          "",          // override REACT_APP_ALPHA_KEY at runtime
  compactRows:       false,       // tighter table rows
  uiMode:            "standard",  // "standard" | "terminal" | "workspace"
  displayName:       "",          // user-chosen display name
  timezone:          "local",     // IANA timezone string or "local"
  profileSetupDone:  false,       // skip ProfileSetup after first setup
  // Billing / tier (synced from Supabase profiles table via useAuth)
  tier:              "free",      // "free" | "pro" | "institutional"
  // Phase 8 additions
  showModuleDescriptions: true,
  accentColor:            "#3ddc84",
  fontSize:               "M",      // "S" | "M" | "L"
  numberFormat:           "abbr",   // "abbr" | "full"
  portfolioValue:         null,     // total portfolio size in USD (display multiplier)
  bio:                    "",       // user bio from onboarding
  country:                "",       // user country from onboarding
  goals:                  [],       // investment goal IDs from onboarding
  languageMode:           "finance",   // "finance" | "plain" — Finance Mode vs Plain English Mode
  onboardingGuideDone:    false,       // true after user completes the 4-step intro guide
  alerts: {
    earnings: true,
    geoRisk:  true,
    price:    false,
    macro:    false,
    weekly:   true,
  },
};

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...SETTINGS_DEFAULTS };
    const parsed = JSON.parse(raw);
    return {
      ...SETTINGS_DEFAULTS,
      ...parsed,
      alerts: { ...SETTINGS_DEFAULTS.alerts, ...(parsed.alerts ?? {}) },
    };
  } catch {
    return { ...SETTINGS_DEFAULTS };
  }
}

function save(settings) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(settings)); } catch {}
}

export function useSettings() {
  const [settings, setSettingsState] = useState(load);

  const setSetting = useCallback((key, value) => {
    setSettingsState(prev => {
      const next = { ...prev, [key]: value };
      save(next);
      return next;
    });
  }, []);

  const resetDefaults = useCallback(() => {
    save(SETTINGS_DEFAULTS);
    setSettingsState({ ...SETTINGS_DEFAULTS });
  }, []);

  return { settings, setSetting, resetDefaults };
}
